// Your existing matcher
function matchDescriptor(nodeDescriptor, target) {
  if (!nodeDescriptor || !target) return false;
  const key = Object.keys(target)[0];
  return nodeDescriptor?.[key] === target[key];
}

/**
 * Find by descriptor and return *exactly* what you want.
 *
 * @param {Array} actions   The full actions tree.
 * @param {Object} descriptor e.g. { ExPt: "prm" }
 * @param {Object} opts
 *   - select: one of:
 *       "context"      -> { level1, sub, node }
 *       "subName"      -> string
 *       "optionName"   -> string
 *       "optionImage"  -> string
 *       string path    -> dot-path into the context, e.g. "sub.name" or "node.price"
 *       function(ctx)  -> any  (ctx is { level1, sub, node })
 *   - all: boolean (default false) -> return first match or array of matches
 *   - defaultValue: any -> value to return if no match
 */
export const findByDescriptor = (actions = [], descriptor, opts = {}) => {
  const { select = "context", all = false, defaultValue = null } = opts;

  const results = [];
  for (const level1 of actions) {
    for (const sub of level1?.subActions || []) {
      const node = dfsFind(sub?.subActions || [], descriptor);
      if (node) {
        const ctx = { level1, sub, node };
        results.push(pick(ctx, select));
        if (!all) return results[0];
      }
    }
  }
  return all ? results : defaultValue;

  // ---- helpers ----

  function dfsFind(nodes = [], target) {
    for (const n of nodes) {
      const children = n?.subActions || [];
      const isLeaf = children.length === 0;

      if (isLeaf) {
        if (matchDescriptor(n?.action?.descriptor, target)) return n;
      } else {
        const found = dfsFind(children, target);
        if (found) return found;
      }
    }
    return null;
  }

  function pick(ctx, sel) {
    if (typeof sel === "function") return sel(ctx);
    if (sel === "context") return ctx;
    if (sel === "subName") return ctx.sub?.name ?? defaultValue;
    if (sel === "optionName") return ctx.node?.name ?? defaultValue;
    if (sel === "optionImage") return ctx.node?.image ?? defaultValue;
    if (typeof sel === "string") return getByPath(ctx, sel, defaultValue);
    return defaultValue;
  }

  function getByPath(obj, path, fallback) {
    if (!path) return fallback;
    return (
      path
        .split(".")
        .reduce((acc, key) => (acc == null ? acc : acc[key]), obj) ?? fallback
    );
  }
};
